import { ApplicationState } from '..';

export const getOrganisers = function getOrganisers(state:ApplicationState) {
    //console.log(state);
    return state.organiser.allIds.map(function (id:string) {
      return state.organiser.byId[id];
    });
};

//export const getSelectedCourse = (state: ApplicationState) => state.course.byId[state.course.ui.selected];

export const getSelectedOrganiser = function getSelectedOrganiser(state:ApplicationState) {
  //console.log("Selected : " + state.course.ui.selected);
  return state.organiser.byId[state.organiser.ui.selected];
};

export const getSelectedOrganiserById = function getSelectedOrganiserById(state:ApplicationState, id:string) {
  //console.log("Selected : " + state.course.ui.selected);
  return state.organiser.byId[id];
};

// export const getCourseByCategory = function getCourseByCategory(state:ApplicationState) {
//     console.log(state);
//     if(state.userReducer.ProfessionalCategory.length === 0){
//       return state.course.Category.map(function (Category:any) {
//         return {
//           Category, 
//           Courses:state.course.byCategory[Category].map(function (id:string) {
//             return state.course.byId[id];
//           })
//         }
//       });
//     }
//     else{
//       if(state.course.Category.length ===0){
//         return [];
//       }
//       else{

      
//         const results:any[] =[];
//          state.userReducer.ProfessionalCategory.map(
//           (professionalCategoty:string) =>{
//             let _category ="";
//             if(professionalCategoty === "Accountant")
//               _category = "Accountancy";
//             else if( professionalCategoty ==="Engineers")
//               _category = "Engineering";
//             else if( professionalCategoty ==="Contractors")
//               _category = "Contractors";
      
//             if( _category !=="" &&  state.course.byCategory[_category] !== undefined)
//             {
//               results.push({Category:_category, Courses:state.course.byCategory[_category].map(function (id:string) {
//                   return state.course.byId[id];
//                 }) 
//               });
//             }
//           }
//         );

//         return results;
//       }
      
//     }
// };
